import { render } from "./Deliverables.vue?vue&type=template&id=ff556a96&scoped=true"
import script from "./Deliverables.vue?vue&type=script&lang=js"
export * from "./Deliverables.vue?vue&type=script&lang=js"

import "./Deliverables.vue?vue&type=style&index=0&id=ff556a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff556a96"]])

export default __exports__